import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const Company = () => {
  const { id } = useParams();
  const [company, setCompany] = useState({});

  const getCompany = async () => {
    let res = await axios(`https://application.eterp.in/company/master/${id}`);
    console.log(res.data);
    setCompany(res.data.data);
  };

  useEffect(() => {
    getCompany();
  }, []);
  console.log(id);
  return (
    <>
      <div
        style={{
          display: "flex",
          // alignItems: "center",
          // justifyContent: "center",
          flexDirection: "column",
          border: "1px solid teal",
          margin: 20,
        }}
      >
        <div
          style={{
            border: "1px solid teal",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h3>Company Name</h3>
          <h3>{company.company_name}</h3>
        </div>

        <div
          style={{
            border: "1px solid teal",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h3>Address</h3>
          <h3>{company.address}</h3>
        </div>
        <div
          style={{
            border: "1px solid teal",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h3>State</h3>
          <h3>{company.state}</h3>
        </div>
        <div
          style={{
            border: "1px solid teal",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h3>City</h3>
          <h3>{company.city}</h3>
        </div>
        <div
          style={{
            border: "1px solid teal",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h3>Gst No</h3>
          <h3>{company.gst_no}</h3>
        </div>
        <div
          style={{
            border: "1px solid teal",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h3>Mobile No</h3>
          <h3>{company.mobile_no}</h3>
        </div>

        <div
          style={{
            border: "1px solid teal",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h3>Email</h3>
          <h3>{company.email}</h3>
        </div>
      </div>

      <div>{!company.key ? <button>Add Database</button> : <></>}</div>
    </>
  );
};
